import environment from "environment";
import { userApi as UserApi, type DropdownItem } from "@fas/ui-framework";
import { requestService } from "../request";
import { userService } from "../user";

type UserItem = {
  username: string;
  id: string;
};

type UsersListResponse = {
  data: {
    data: {
      usersList: UserItem[];
    };
  };
};

export const getUsersList = (searchStr?: string, limit?: number): Promise<DropdownItem<string>[]> => requestService
  .get(environment.endpoints.get.usersList, {
    params: {
      searchStr,
      limit,
    },
  }).then((result: UsersListResponse) => result.data.data.usersList.map((i) => ({ label: i.username, value: i.id })));

export const updateUserRole = (userId: string, role: number): Promise<unknown> => requestService
  .put(environment.endpoints.put.users.replace("{id}", userId), { role });

// eslint-disable-next-line import/prefer-default-export
export const userApiService: UserApi = new UserApi(userService, requestService);
